import {ReactNode} from "react";
import {Sheet, SheetProps} from "@mui/joy";

interface GlassCardProps extends Omit<SheetProps, "variant"> {
    children: ReactNode;
}

// Stesso linguaggio visivo delle GlassCard su Flutter (blur "thinMaterial",
// bordo bianco sottile, radius 16) — usata ovunque nel portale al posto
// dei vari Sheet/Card sparsi con stili diversi, per coerenza con l'app.
export function GlassCard({children, sx, ...rest}: GlassCardProps) {
    return (
        <Sheet
            variant="outlined"
            sx={{
                p: 3,
                borderRadius: 16,
                backgroundColor: "rgba(255,255,255,0.04)",
                borderColor: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Sheet>
    );
}
